module.exports = __webpack_public_path__ + "img/daolan.6efe96c9.png";